import React, { useEffect } from 'react';
import LiaPage from './LiaPage';
import { APP_SUBDOMAINS, subdomainUrl } from '../../subdomains/portal';
import { probeSubdomain } from '../../subdomains/useSubdomainUrl';

/**
 * www.mof.gov.tl/lia: moves the visitor to lia.mof.gov.tl once their network can reach it.
 * Networks that cannot (seen on Timor Telecom) stay here, so the page always works.
 */
export default function LiaPortalPage() {
    useEffect(() => {
        if (!APP_SUBDOMAINS.lia.live) return undefined;
        let active = true;
        probeSubdomain('lia').then((reachable) => {
            if (active && reachable) {
                window.location.replace(`${subdomainUrl('lia', '/')}${window.location.hash}`);
            }
        });
        return () => {
            active = false;
        };
    }, []);

    return <LiaPage />;
}
